import { render } from "./LoadingModal.vue?vue&type=template&id=6782630a&scoped=true"
import script from "./LoadingModal.vue?vue&type=script&lang=js"
export * from "./LoadingModal.vue?vue&type=script&lang=js"

import "./LoadingModal.vue?vue&type=style&index=0&id=6782630a&scoped=true&lang=css"

import exportComponent from "../../../../CPSDashApontamento/apontamentowebvueV3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6782630a"]])

export default __exports__